const apiVersion = 'v1'

let url = 'https://loca.shop/'
let domain = 'https://api.loca.shop/'
let cdnDomain = 'https://images.loca.shop/'
let adminUrl = 'https://gestao.loca.shop/'
let locashopUrl = 'https://loca.shop/'
let displayUrl = 'https://loca.shop/'

if (process.env.NODE_ENV !== 'production') {
  url = 'http://localhost:8080/'
  domain = 'http://localhost/'
  cdnDomain = 'http://localhost/'
  adminUrl = 'http://localhost:3000'
  locashopUrl = 'http://localhost:8080/'
  displayUrl = 'http://localhost:8081/'
}

export const companyName = 'Loca.Shop'
export const companyCnpj = '28.872.852/0001-98'
export const companyAddress = 'R. Zircônio, 288, Camargos, Belo Horizonte/MG - CEP: 30520-170'

export const appDomain = url
export const apiDomain = domain
export const adminURL = adminUrl
export const locashopURL = locashopUrl
export const displayURL = displayUrl
export const apiURL = apiDomain + apiVersion + '/display'
export const cdnURL = cdnDomain

export const userURL = 'user'
export const companyURL = 'companies'
export const usersURL = 'users'
export const loginURL = apiDomain + 'oauth/token'
export const passwordEmailURL = 'password/email'
export const passwordResetURL = 'password/reset'



// WEBPACK FOOTER //
// ./src/config.js